import { render, staticRenderFns } from "./viewBitacora.vue?vue&type=template&id=5dd9247c&"
import script from "./viewBitacora.vue?vue&type=script&lang=js&"
export * from "./viewBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports